import type { UserConfidenceRange } from './converters';

const isUserConfidenceRange = (value: unknown): value is UserConfidenceRange => {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return false;
  const v = value as Record<string, unknown>;
  return (
    typeof v.min === 'number' &&
    typeof v.max === 'number' &&
    typeof v.template === 'string'
  );
};

export const sanitizeUserConfidenceRanges = (
  raw: unknown
): UserConfidenceRange[] | null => {
  if (raw === null || raw === undefined) return null;
  if (Array.isArray(raw)) {
    if (raw.length === 0) return [];
    const valid = raw.filter(isUserConfidenceRange);
    return valid.length > 0 ? valid : null;
  }
  return null;
};

export const formatUserConfidenceRangesForApi = (
  ranges: UserConfidenceRange[] | null | undefined
): { min: number; max: number; template: string }[] | null => {
  if (ranges == null) return null;

  return ranges.map(r => ({
    min: Number(r.min),
    max: Number(r.max),
    template: r.template,
  }));
};
